import { ENVIRONMENTS } from './environment';
import { DEVELOPER_DOMAIN } from './Developer';

// Product readiness gate: MCP connector UI is enabled for allowlisted domains.
export const MCP_CONNECTOR_UI_ENABLED = true;

export const MCP_CONNECTOR_ENABLED_ENVIRONMENTS: Array<ENVIRONMENTS> = [
  ENVIRONMENTS.development,
  ENVIRONMENTS.uat,
  ENVIRONMENTS.production,
];

export const MCP_CONNECTOR_ALLOWED_DOMAINS = [DEVELOPER_DOMAIN];

export const isMcpConnectorDomainAllowed = (
  domainName: string | null | undefined,
): boolean => {
  if (!domainName) {
    return false;
  }

  const normalizedDomainName = domainName.trim().toLowerCase();

  if (!MCP_CONNECTOR_ALLOWED_DOMAINS.length) {
    return true;
  }

  return MCP_CONNECTOR_ALLOWED_DOMAINS.includes(normalizedDomainName);
};
